// extracted by mini-css-extract-plugin
export default {"root":"root--U667K","arrow":"arrow--U667K","sectionHeading":"sectionHeading--U667K","moreLink":"moreLink--U667K"};